/**
 * Component Registry for Quinn Residences at McCart Landing
 * 
 * Inherits from @vibesites-quinn-residences/theme-websites and allows property-specific overrides.
 */

import type { ComponentRegistry } from '@vibesites/runtime';
import { registry as parentRegistry } from '@vibesites-quinn-residences/theme-websites/registry';
import { ContactDetails } from './components/ContactDetails';
import { FaqHelp } from './components/FaqHelp';
import { Footer } from './components/Footer';
import { ThankYou } from './components/ThankYou';
import { TourOptions } from './components/TourOptions';
import { VisitUs } from './components/VisitUs';

/**
 * Property-specific component overrides.
 * Uncomment and customize components as needed.
 */
const propertyOverrides: Partial<ComponentRegistry> = {
  ContactDetails,
  FaqHelp,
  Footer,
  ThankYou,
  TourOptions,
  VisitUs,
};

/**
 * Final merged registry for this property.
 * Inherits all components from the parent theme, with property overrides.
 */
export const registry: ComponentRegistry = {
  ...parentRegistry,
  ...propertyOverrides,
};

export default registry;
